// extracted by mini-css-extract-plugin
export default {"bad":"style_bad__dZklc","moderate":"style_moderate__1Q8rJ","good":"style_good__e8-TR","body":"style_body__DVe-a"};